import React from "react";
import { withRouter } from "react-router";

import { IWithRouteMatchProps } from "./RouteContext";

export interface IWithRoutePropsProps<T> extends IWithRouteMatchProps {
  routeProps: T;
}

export function withRouteProps<P, T>(
  Component: React.ComponentType<P>,
  transformSelector: (props: IWithRouteMatchProps) => T,
) {
  type Props = IWithRoutePropsProps<T> & P;

  class RouteProps extends React.PureComponent<Props> {
    render() {
      const routeProps = transformSelector(this.props);

      return <Component {...this.props} routeProps={routeProps} />;
    }
  }

  return withRouter(RouteProps);
}
